import type { ReactNode } from 'react'

import { ConfirmDialog } from '@mangovoice/mango-ui'

import { useHotelsI18n } from '../../i18n'

interface ConfirmationDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  description?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  confirmColorPalette?: string
  isSubmitting?: boolean
}

const DESTRUCTIVE_PALETTES = ['red', 'danger']

export const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel,
  cancelLabel,
  confirmColorPalette = 'red',
  isSubmitting = false,
}: ConfirmationDialogProps) => {
  const { text } = useHotelsI18n()

  const descriptionStr =
    typeof description === 'string' ? description : undefined
  const descriptionChildren: ReactNode =
    typeof description !== 'string' && description ? description : undefined

  const variant = DESTRUCTIVE_PALETTES.includes(confirmColorPalette)
    ? 'destructive'
    : 'default'

  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      description={descriptionStr}
      confirmLabel={confirmLabel ?? text('hotels.dialogs.confirm', 'Confirm')}
      cancelLabel={cancelLabel ?? text('hotels.dialogs.cancel', 'Cancel')}
      variant={variant}
      isLoading={isSubmitting}
      children={descriptionChildren}
    />
  )
}
